import {
  MemberMessagesDismissedModel,
  MemberMessagesDismissedResponse,
} from 'app/gamma/src/types';

import genericNormalizer from './generic';

export const normalizeMessagesDismissed = genericNormalizer<
  MemberMessagesDismissedResponse,
  MemberMessagesDismissedModel
>(({ from }) => ({
  _id: from('_id'),
  count: from('count'),
  lastDismissed: from('lastDismissed'),
  name: from('name'),
}));
